import { batch, useDispatch } from 'react-redux'
import NoneAnchor from 'components/NoneAnchor'
import PropTypes from 'prop-types'
import { useDashboardTableActions } from 'features/dashboard/utils/hooks/useDashboardTableActions'
import { CampaignTypes, DashboardTypes } from 'features/Codes'
import { setType } from 'features/dashboard/dashboardCommonSlice'
import { adGroupTableActions } from 'features/dashboard/table/adGroup/adGroupTableSlice'
import { keywordTableActions } from 'features/dashboard/table/keyword/keywordTableSlice'
import { creativeTableActions } from 'features/dashboard/table/creative/creativeTableSlice'
import {
  addActives,
  addExpandCampaignType,
  setCampaignId,
} from 'features/dashboard/tree/dashboardTreeSlice'
import { fetchDashboardInfoCampaign } from 'features/dashboard/info/dashboardInfoSlice'

const CampaignLink = ({
  id,
  campaignType = CampaignTypes.PREMIUM_LINK,
  className = 'link_txt',
  children,
}) => {
  const dispatch = useDispatch()
  const { setSelectedIds } = useDashboardTableActions(DashboardTypes.CAMPAIGN)
  return (
    <NoneAnchor
      className={className}
      onClick={() => {
        batch(() => {
          dispatch(setCampaignId(id))
          dispatch(addExpandCampaignType(campaignType))
          dispatch(addActives(id))
          dispatch(
            fetchDashboardInfoCampaign({
              id,
              showError: true,
            })
          )
          dispatch(adGroupTableActions.setPage(0))
          dispatch(keywordTableActions.setPage(0))
          dispatch(creativeTableActions.setPage(0))
          dispatch(setSelectedIds([id]))
          dispatch(setType(DashboardTypes.AD_GROUP))
        })
      }}>
      {children}
    </NoneAnchor>
  )
}
CampaignLink.propTypes = {
  id: PropTypes.string.isRequired,
  campaignType: PropTypes.oneOf([
    CampaignTypes.PREMIUM_LINK,
    CampaignTypes.TALK_CHANNEL,
  ]),
  className: PropTypes.string,
  children: PropTypes.node,
}
export default CampaignLink
